(function () {
  var el = document.querySelector('[data-btg-tilt]');
  if (!el) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ticking = false;

  function update() {
    var rect = el.getBoundingClientRect();
    var viewportH = window.innerHeight || document.documentElement.clientHeight;
    var progress = 1 - (rect.top + rect.height / 2) / viewportH;
    progress = Math.max(-1, Math.min(1, progress));

    var rotateY = -10 + progress * 22;
    var rotateX = progress * -4;

    el.style.transform = 'rotateY(' + rotateY.toFixed(2) + 'deg) rotateX(' + rotateX.toFixed(2) + 'deg)';
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  update();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
})();
